import { isFilled } from '@prismicio/helpers'
import { ContentRelationshipField, KeyTextField } from '@prismicio/types'
import { cache } from 'react'

import { createClient } from '@/prismicio'

export type BlogAuthor = {
    author_full_name: string
    author_title?: string
    id: string
    author_avatar: {
        url: string
    }
}

type Data = {
    authors: BlogAuthor[]
}

export const getAuthors = cache(async (): Promise<Data> => {
    const client = createClient()
    const authors = await client.getAllByType('author')
    return {
        authors: authors.map((a) => {
            return {
                author_full_name: a.data.author_full_name as string,
                author_title: a.data.author_title as string,
                author_avatar: {
                    url:
                        a.data.author_avatar.url ||
                        'https://images.prismic.io/luneco/b1a4704c-7a99-463a-ad4f-afac057fe919_Lune_icon.jpg?auto=compress,format',
                },
                id: a.id,
            }
        }),
    }
})

export const getAuthor = (
    authors: BlogAuthor[] | null,
    authorData: ContentRelationshipField<'author'>,
) => {
    if (authors === null) {
        throw new Error('Unexpected property type(s) or authorData is empty')
    }

    if ('id' in authorData && authorData.id) {
        const author = authors.find((a) => a.id === authorData.id)
        if (!author) {
            throw new Error('Author not found')
        }
        if (
            !isFilled.keyText(author.author_full_name) ||
            !isFilled.image(author.author_avatar as any)
        ) {
            throw new Error('Unexpected property type(s)')
        }

        return {
            name: author.author_full_name,
            title: author.author_title,
            avatar: author.author_avatar.url,
        }
    } else {
        throw new Error('Unexpected property type(s) or authorData is empty')
    }
}

export const getValidatedCustomLabel = (label: KeyTextField) => {
    if (!label) {
        return
    }

    if (!isFilled.keyText(label)) {
        throw new Error('Unexpected property type(s)')
    }

    return label
}
